import React from 'react';
import { nanoid } from 'nanoid';
import { Col, Modal, Row } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { CustomButtonNovo } from '~/components/Buttons/CustomButtonNovo';
import { InputSelect, InputText } from '~/components/NovosInputs';
import { SelectType } from '~/components/NovosInputs/InputSelect/protocols';
import { insertOrUpdate } from '~/utils/masterDetail';
import { useProduto } from '../../../hooks/useProduto';
import { useProdutoQueries } from '~/pages/Produto/hooks/useQueriesProduto';

export const ModalDerivado: React.FC = () => {
  const {
    openModalDerivado,
    handleOpenModalDerivado,
    registerDerivado,
    controlDerivado,
    formStateDerivado: { errors },
    setValueDerivado,
    clearErrorsDerivado,
    watchDerivado,
    handleSubmitDerivado,
    isEditingDerivado,
    setLoadingTableDerivado,
    rowsDerivado,
    setRowsDerivado,
    masterDetail,
    setMasterDetail,
  } = useProduto();
  const desProduto = watchDerivado('des_produto');
  const { tiposDeAjuste, departamentos, unidades } = useProdutoQueries();
  const unVendas = unidades.data?.unVendas ?? [];

  const onSaveDerivado = handleSubmitDerivado(async (data) => {
    setLoadingTableDerivado(true);

    const produtoExistente = rowsDerivado.find(
      (i) => i.des_produto.trim() === data.des_produto.trim(),
    );

    if (!isEditingDerivado && produtoExistente) {
      toast.warn('Descrição já vinculada');
      setLoadingTableDerivado(false);
      return;
    }

    try {
      const productToUpdate = isEditingDerivado ? produtoExistente : null;

      const insertValues = {
        ...data,
        uuid: productToUpdate?.uuid ?? nanoid(),
        cod_produto_derivado: productToUpdate?.cod_produto_derivado,
        des_unidade: productToUpdate
          ? productToUpdate.des_unidade
          : data.des_unidade || null,
        cod_tipo_ajuste: data.cod_tipo_ajuste,
        cod_seq_produto_derivado: productToUpdate
          ? productToUpdate.cod_seq_produto_derivado
          : null,
      };

      const rowsDetail: any[] = await insertOrUpdate(
        'produtos-derivados',
        insertValues,
        masterDetail,
        setMasterDetail,
      );

      setRowsDerivado(rowsDetail);
      handleOpenModalDerivado(false);

      if (isEditingDerivado) {
        toast.success('Ajuste atualizado com sucesso');
      }
    } catch (error: any) {
      toast.warn(`Erro ao adicionar produto derivado: ${error.message}`);
    } finally {
      setLoadingTableDerivado(false);
    }
  });

  return (
    <>
      <Modal
        show={openModalDerivado}
        animation
        onHide={() => {
          handleOpenModalDerivado(false);
        }}
        centered
        size="lg"
      >
        <Modal.Header>
          <Modal.Title
            style={{
              whiteSpace: 'normal',
              wordBreak: 'break-word',
              overflowWrap: 'break-word',
              maxWidth: '100%',
            }}
          >
            {!isEditingDerivado
              ? `Novo produto derivado de ${desProduto ?? ''} `
              : `Editar ${desProduto ?? ''}`}
          </Modal.Title>
          <button
            type="button"
            onClick={() => handleOpenModalDerivado(false)}
            style={{
              right: '10px',
              top: '10px',
              fontSize: '20px',
              cursor: 'pointer',
              outline: 'none',
              background: 'none',
              border: 'none',
            }}
          >
            x
          </button>
        </Modal.Header>
        <Modal.Body>
          {!isEditingDerivado && (
            <>
              <Row>
                <Col sm={12} md={9}>
                  <InputText
                    id="desProdDerivado"
                    label="Nome do Produto Genérico *"
                    name="des_produto"
                    maxLength={50}
                    placeholder="Informe o Nome do Produto Genérico"
                    register={registerDerivado}
                    caseInput="upper"
                    control={controlDerivado}
                    isError={!!errors.des_produto}
                  />
                </Col>
                <Col sm={12} md={3}>
                  <InputSelect
                    label="Emb. *"
                    name="des_unidade"
                    options={unVendas as SelectType[]}
                    placeholder="Selecione"
                    defaultOption={false}
                    register={registerDerivado}
                    control={controlDerivado}
                    isError={!!errors.des_unidade}
                    changeSelected={(selected: SelectType) => {
                      setValueDerivado('des_unidade', selected);
                      clearErrorsDerivado('des_unidade');
                      document.getElementById('departamento')?.focus();
                    }}
                  />
                </Col>
              </Row>
              <Row>
                <Col sm={12} md={12}>
                  <InputSelect
                    id="departamento"
                    label="Departamento *"
                    placeholder="Selecione o Departamento"
                    name="cod_departamento"
                    register={registerDerivado}
                    isError={!!errors.cod_departamento}
                    control={controlDerivado}
                    options={departamentos.data as SelectType[]}
                    changeSelected={(selected: SelectType) => {
                      setValueDerivado('cod_departamento', selected);
                      clearErrorsDerivado('cod_departamento');
                      document.getElementById('tipoAjuste')?.focus();
                    }}
                  />
                </Col>
              </Row>
            </>
          )}
          <Row>
            <Col sm={12} md={12}>
              <InputSelect
                id="tipoAjuste"
                label="Ajuste Padrão de Produção *"
                placeholder="Selecione o Tipo de Ajuste"
                name="cod_tipo_ajuste"
                register={registerDerivado}
                isError={!!errors.cod_tipo_ajuste}
                control={controlDerivado}
                options={tiposDeAjuste.data as SelectType[]}
                changeSelected={(selected: SelectType) => {
                  setValueDerivado('cod_tipo_ajuste', selected);
                  clearErrorsDerivado('cod_tipo_ajuste');
                  setTimeout(() => {
                    document.getElementById('btnSubmit')?.focus();
                  }, 10);
                }}
              />
            </Col>
          </Row>
          <Row
            style={{
              display: 'flex',
              justifySelf: 'center',
              gap: '10px',
              marginTop: '20px',
            }}
          >
            <CustomButtonNovo
              id="btnSubmit"
              type="submit"
              label={isEditingDerivado ? 'OK' : 'CRIAR PRODUTO DERIVADO'}
              style={{ backgroundColor: '#009e0f' }}
              width={isEditingDerivado ? '' : '400px'}
              onClick={onSaveDerivado}
            />
            <CustomButtonNovo
              type="button"
              hidden={!isEditingDerivado}
              label="Cancelar"
              style={{ backgroundColor: '#cf2a27' }}
              onClick={() => handleOpenModalDerivado(false)}
            />
          </Row>
        </Modal.Body>
      </Modal>
    </>
  );
};
